import classNames from "classnames";

export interface PoweredByEndearProps {
  className?: string;
}

export function PoweredByEndear(props: PoweredByEndearProps) {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className={classNames(
        "uppercase font-medium tracking-wide text-sm transition focus:outline-none focus:ring rounded-full",
        props.className,
      )}
      href="https://endearhq.com?utm_source=endear_redirects&amp;utm_campaign=powered_by&amp;utm_medium=lookbook">
      Powered by Endear
    </a>
  );
}
